import { formatDequeueOn, formatDequeueOnFull, parseDequeueOn } from '../../utils/formatDequeueOn';

export default function ThreadQueueStatus({ thread }) {
  // A closed thread is not released from the queue until it is reopened
  if (!thread?.is_waiting || thread.is_active === false) return null;

  const dequeueOn = parseDequeueOn(thread.dequeue_on);

  if (!dequeueOn) {
    return <div className="thread-queue-status">No dequeue time set</div>;
  }

  return (
    <div className="thread-queue-status" title={formatDequeueOnFull(dequeueOn)}>
      Dequeues {formatDequeueOn(dequeueOn)}
    </div>
  );
}
